import React, { useEffect, useState } from "react";
import { QuestionFeedback } from "../components/QuestionPage/QuestionFeedback";
import { AnimatePresence, motion } from "framer-motion";
import { Question } from "../components/QuestionPage/Question";
export function QuestionPage({ question, comesFromBacktracking, onAnswered, questionPosition }) {
    const [showFeedback, setShowFeedback] = useState(!question.feedback_text);
    const [characterPosition, setCharacterPosition] = useState('middle');
    useEffect(() => {
        setShowFeedback(!!question.feedback_text && !comesFromBacktracking);
    }, [question]);
    useEffect(() => {
        let characterPosition;
        switch (questionPosition % 3) {
            case 1:
                characterPosition = 'end';
                break;
            case 2:
                characterPosition = 'middle';
                break;
            case 0:
                characterPosition = 'start';
                break;
            default:
                characterPosition = 'middle';
        }
        setCharacterPosition(characterPosition);
    }, [questionPosition]);
    return (React.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } },
        React.createElement(AnimatePresence, null,
            showFeedback && (React.createElement(QuestionFeedback, { key: "QuestionFeedback", title: question.feedback_title, text: question.feedback_text, characterPosition: characterPosition, onAccepted: () => setShowFeedback(false) })),
            !showFeedback && (React.createElement(Question, { key: "Question", question: question, onAnswered: onAnswered, characterPosition: characterPosition })))));
}
